import script from "./DiscordPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscordPage.vue?vue&type=script&setup=true&lang=js"

import "./DiscordPage.vue?vue&type=style&index=0&id=1777c968&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1777c968"]])

export default __exports__